"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof3 = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));
var _react = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _Title = _interopRequireDefault(require("../../Title"));
var _utils = require("../../utils");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof3(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var __assign = void 0 && (void 0).__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
function PictureComponent(props) {
  var imageSrc = props.imageSrc;
  var _a = (0, _utils.fomateFileData)(imageSrc),
    url = _a.url,
    _b = _a.alt,
    alt = _b === void 0 ? '' : _b;
  var _c = (0, _react.useState)({}),
    styles = _c[0],
    setStyls = _c[1];
  // console.log(styles);
  (0, _react.useEffect)(function () {
    var imgLoad = new Image();
    if (url) {
      imgLoad.src = url;
    }
    imgLoad.onload = function () {
      var collectStyles = {};
      if (imgLoad.width < imgLoad.height) {
        collectStyles = {
          height: '100%',
          width: 'auto'
        };
      } else {
        collectStyles = {
          width: '100%',
          height: 'auto'
        };
      }
      // console.log(imgLoad.width, imgLoad.height, 'styles');
      setStyls(collectStyles);
    };
  }, []);
  return /*#__PURE__*/_react["default"].createElement("img", {
    style: __assign({
      margin: '0 auto',
      maxWidth: '258px',
      maxHeight: '66px'
    }, styles),
    src: url,
    alt: alt
  });
}
var Thumbnail = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
  var icon = props.icon,
    banner = props.banner,
    sharp = props.sharp,
    radius = props.radius,
    configuration = props.configuration,
    flexTitle = props.flexTitle,
    style = props.style,
    className = props.className,
    onClick = props.onClick,
    restProps = __rest(props, ["icon", "banner", "sharp", "radius", "configuration", "flexTitle", "style", "className", "onClick"]);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: 'flex-default-flex-brand-container',
    style: (0, _typeof2["default"])(style) === 'object' ? style : {}
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: 'flex-default-flex-brand-container-children'
  }, /*#__PURE__*/_react["default"].createElement(_Title["default"], {
    title: flexTitle
  }), /*#__PURE__*/_react["default"].createElement("div", __assign({
    className: (0, _classnames["default"])('flex-brand-default-class', {}),
    ref: ref
  }, restProps), configuration.map(function (items, index) {
    var _a = items || {},
      imageSrc = _a.imageSrc,
      title = _a.title,
      href = _a.href,
      extendProps = _a.extendProps;
    return (
      // <section key={index} className={'flex-brand-list'}>
      href ? (/*#__PURE__*/_react["default"].createElement("a", __assign({
        className: 'flex-default-container-list-a',
        href: href
      }, extendProps || {}), /*#__PURE__*/_react["default"].createElement("div", __assign({
        className: (0, _classnames["default"])('flex-default-container-brand-class__list', className),
        style: {
          height: "" + (configuration.length >= 5 ? '131px' : '115px')
        },
        key: index
      }, restProps), /*#__PURE__*/_react["default"].createElement("div", {
        className: 'brand-list-img'
      }, /*#__PURE__*/_react["default"].createElement(PictureComponent, {
        imageSrc: imageSrc || 'https://staticintl.cloudcachetci.com/cms/backend-cms/kZGm326_Frame.png'
      })), /*#__PURE__*/_react["default"].createElement("div", {
        className: 'brand-hr-class'
      }), /*#__PURE__*/_react["default"].createElement("div", {
        className: 'brand-txt'
      }, title)))) : (/*#__PURE__*/_react["default"].createElement("div", __assign({
        className: (0, _classnames["default"])('flex-default-container-brand-class__list', className),
        style: {
          height: "" + (configuration.length >= 5 ? '131px' : '115px')
        },
        key: index
      }, restProps), /*#__PURE__*/_react["default"].createElement("div", {
        className: 'brand-list-img'
      }, /*#__PURE__*/_react["default"].createElement(PictureComponent, {
        imageSrc: imageSrc || 'https://staticintl.cloudcachetci.com/cms/backend-cms/kZGm326_Frame.png'
      })), /*#__PURE__*/_react["default"].createElement("div", {
        className: 'brand-hr-class'
      }), /*#__PURE__*/_react["default"].createElement("div", {
        className: 'brand-txt'
      }, title)))
      // </section>
    );
  }))));
});
Thumbnail.displayName = 'TCIThumbnail';
var _default = exports["default"] = Thumbnail;